export default "__VITE_ASSET__722a3f15__"